<template>
  <div>
    <slot name="channel" v-bind="{ selectedChannel, channelColor }">
      <span :style="{ color: channelColor }">
        <em v-if="selectedChannel.icon" :class="selectedChannel.icon" /> {{ selectedChannel.text }}
      </span>
    </slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ChannelLabel',
  props: ['channel'],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedChannel() {
      if (this.selectedBot.theme == 'seagull' && this.channel === 'others') {
        return {
          value: 'others',
          fullValue: 'others',
          fullValueForUse: 'others',
          text: 'Others',
          icon: 'fas fa-running',
          color: '#3b5998'
        }
      }
      const selectedChannel = this.$store.state.socialChannelOptions.find((channel) => {
        return channel.fullValue === this.channel
      })
      return (
        selectedChannel || {
          value: 'other',
          fullValue: 'other',
          fullValueForUse: 'other',
          text: 'Other',
          icon: ''
        }
      )
    },
    channelColor() {
      const selectedChannel = this.$store.state.socialChannelOptions.find((channel) => {
        return channel.fullValue === this.channel
      })
      if (this.selectedBot.theme == 'seagull' && this.channel === 'others') {
        return '#3b5998'
      }
      switch (selectedChannel.fullValue) {
        case 'facebook':
          return '#3b5998'
        case 'line':
          return '#00c300'
        case 'instagram':
          return '#c13584'
        default:
          return 'grey'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ChannelLabel.vue